const address = `
    firstname
    lastname
    street
    city
    region {
        code    
        label
    }
    postcode
    country {
        code
        label
    }
    telephone
`;

const money =`{
    value
    currency
}`;

const items = `
    itemsV2(pageSize: 100) {
        items {
            id
            product {
                name
                sku
                url_key
                stock_status
                image {
                    url
                    label               
                }
                display_weight
                additional_attribute_data {
                    label
                    value
                    option_id
                    code
                }
                stock_data {
                    max_sale_qty
                }
                producttypeinenglish
                price_range {
                    minimum_price {
                        regular_price {
                            value
                            currency
                        }
                        final_price {
                            value
                            currency
                        }
                        discount {
                            percent_off
                            amount_off
                        }
                    }
                }
            }
            quantity
            prices {
                row_total ${money}
                row_total_including_tax ${money}
            }
        }
    }
`;

const cart = `{
    id
    email
    is_cart_merged
    cart_points {
        bwfo_cash {
            value
            currency
        }
        vip_bwfo_cash {
            value
            currency
        }
        allowed_to_save {
            value
            currency
        }
        saved_amount {
            value
            currency
        }
        customer_bwfo_cash_balance {
            value
            currency
        }
    }
    ${items}
    total_quantity
    is_virtual
    prices {
        subtotal_excluding_tax ${money}
        applied_taxes {
            amount ${money}
        }
        discounts {
            label
            amount ${money}
        }
        grand_total ${money}
    }
    applied_gift_cards {
        code
    }
    applied_coupons {
        code
    }
    shipping_addresses {
        ${address}
        available_shipping_methods {
            amount {
                currency
                value
            }
            carrier_code
            carrier_title
            method_code
            method_title
            estimated_delivery_formatted_message
        }
        selected_shipping_method {
            carrier_code
            carrier_title
            method_code
            method_title
            amount {
                value
                currency
            }
        }
    }
    billing_address {
        ${address}
    }
    available_payment_methods {
        code
        title
    }
    selected_payment_method {
        code
        title
        public_hash
    }
    selected_shipping_address_id
    selected_billing_address_id
    billing_address_as_shipping
}`;

const getCart = id => `{
    cart(cart_id: "${id}") ${cart}
}`;

const getCustomerCart = `{
    customerCart ${cart}
}`;

const createEmptyCart = `
    mutation {
        createEmptyCart
    }
`;

const addProductsToCart = `
    mutation AddProductsToCart($cartId: String!, $cartItems: [CartItemInput!]!) {
        addProductsToCart(cartId: $cartId, cartItems: $cartItems) {
            cart ${cart}
            user_errors {
                code
                message
            }
        }
    }
`;

const removeItemFromCart = `
    mutation RemoveItemFromCart($input: RemoveItemFromCartInput) {
        removeItemFromCart(input: $input) {
            cart ${cart}
        }
    }
`;

const reOrder = `
    mutation Reorder($orderNumber: String!) {
        reorderItems(orderNumber: $orderNumber) {
            cart ${cart}
        }
    }
`;

const updateCartItems = `
    mutation UpdateCartItems($input: UpdateCartItemsInput) {
        updateCartItems(input: $input) {    
            cart ${cart}   
        }
    }
`;

const applyGiftCardToCart = `
    mutation ApplyGiftCardToCart($input: ApplyGiftCardToCartInput) {
        applyGiftCardToCart(input: $input) {
            cart ${cart}
        }
    }
`;

const removeGiftCardFromCart = `
    mutation RemoveGiftCardFromCart($input: RemoveGiftCardFromCartInput) {
        removeGiftCardFromCart(input: $input) {
            cart ${cart}
        }
    }
`;

const applyCouponToCart = `
    mutation ApplyCouponToCart($input: ApplyCouponToCartInput) {
        applyCouponToCart(input: $input) {
            cart ${cart}  
        }
    }
`;

const removeCouponFromCart = `
    mutation RemoveCouponFromCart($input: RemoveCouponFromCartInput) {
        removeCouponFromCart(input: $input) {
            cart ${cart}
        }
    }
`;

const mergeCarts = `
    mutation MergeCarts($source_cart_id: String!, $destination_cart_id: String!, $action: MergeCartsStrategy) {
        mergeCarts(source_cart_id: $source_cart_id, destination_cart_id: $destination_cart_id, action: $action)
        ${cart}
    }
`;

const setGuestEmailOnCart = `
    mutation SetGuestEmailOnCart($input: SetGuestEmailOnCartInput) {
        setGuestEmailOnCart(input: $input) {
            cart ${cart}
        }
    }
`;

const setShippingAddressesOnCart = `
    mutation SetShippingAddressesOnCart($input: SetShippingAddressesOnCartInput) {
        setShippingAddressesOnCart(input: $input) {
            cart ${cart}
        }
    }
`;

const setBillingAddressOnCart = `
    mutation SetBillingAddressOnCart($input: SetBillingAddressOnCartInput) {
        setBillingAddressOnCart(input: $input) {
            cart ${cart}
        }
    }
`;

const setShippingMethodsOnCart = `
    mutation SetShippingMethodsOnCart($input: SetShippingMethodsOnCartInput) {
        setShippingMethodsOnCart(input: $input) {
            cart ${cart}
        }
    }
`;

const setPaymentMethodOnCart = `
    mutation SetPaymentMethodOnCart($input: SetPaymentMethodOnCartInput) {
        setPaymentMethodOnCart(input: $input) {
            cart ${cart}
        }
    }
`;

const placeOrder = `
    mutation PlaceOrder($input: PlaceOrderInput) {
        placeOrder(input: $input) {
            orderV2 {
                number
                token
                customer_access_token
                order_invitation_data
                enhanced_conversion_data {
                    email
                    telephone
                    firstname
                    lastname
                    street
                    city
                    region
                    postcode
                    country
                }
                email
                items {
                    id
                    product {
                        name
                        sku
                        image {
                            url
                            label
                        }
                    }
                    product_sale_price ${money}
                    quantity_ordered
                }        
                status
                shipping_method
                shipping_address {
                    firstname
                    lastname
                    street
                    postcode
                    city
                    country_code
                    postcode
                    region
                }
                payment_methods {
                    name
                    type
                }
                total {
                    discounts {
                        label
                        amount ${money}
                    }
                    taxes {
                        amount ${money}
                    }
                    total_shipping ${money}
                    subtotal ${money}
                    grand_total ${money}
                    total_tax ${money}
                }
            }
            errors {
                message
                code
                item_id
            }
        }
    }
`;

const completeStripePayment = `
    mutation CompleteStripePayment($number: String) {
        completeStripePayment(number: $number)       
    }
`;

const getCardnetPaymentStatus = `
    query GetCardnetPaymentStatus($number: String!) {
        getCardnetPaymentStatus(number: $number) {
            secure_challenge_form
            secure_method_form
        }
    }
`;

const processCardnetPaymentSecureChallenge = `
    query ProcessCardnetPaymentSecureChallenge($number: String!) {
        processCardnetPaymentSecureChallenge(number: $number) {
            secure_challenge_form
        }
    }
`;

const restoreQuote = `
    mutation RestoreQuote($number: String) {
        restoreQuote(number: $number)       
    }
`;

const getStripeRequiresAction = `
    query GetStripeRequiresAction($number: String) {
        getStripeRequiresAction(number: $number)       
    }
`;

const createPaymentOrder = `
    mutation CreatePaymentOrder($input: CreatePaymentOrderInput!) {
        createPaymentOrder(input: $input) {
            id
        } 
    }
`;

const amazonPayConfig = `
    query CheckoutSessionConfig($cartId: String) {
        checkoutSessionConfig(cartId: $cartId) {
            paynow_payload
            paynow_signature
        }
    }
`;

const amazonExpressConfig = `
    query CheckoutSessionConfig($cartId: String) {
        checkoutSessionConfig(cartId: $cartId) {
            checkout_payload
            checkout_signature
        }
    }
`;

const amazonExpressPay = `
    mutation UpdateCheckoutSession($cartId: String!, $amazonSessionId: String!) {
        updateCheckoutSession(cartId: $cartId, amazonSessionId: $amazonSessionId) {
            redirectUrl
        }
    }
`;

const updateRewardPoints = `
    mutation UpdateRewardPoints($currency_amount: Float!) {
        updateRewardPoints(currency_amount: $currency_amount) {
            cart ${cart}
        }
    }
`;

const generateExtendedHash = `
    query GenerateExtendedHash($order_number: String!) {
        generateExtendedHash(order_number: $order_number) {
            chargetotal
            checkoutoption
            currency
            customerid
            hash_algorithm
            invoicenumber
            paymentMethod
            ponumber
            responseFailURL
            responseSuccessURL
            storename
            timezone
            transactionNotificationURL
            txndatetime
            txntype
            hashExtended
        }
    }
`;

export default {
    getCart,
    getCustomerCart,
    createEmptyCart,
    addProductsToCart,
    removeItemFromCart,
    reOrder,
    updateCartItems,
    applyGiftCardToCart,
    removeGiftCardFromCart,
    applyCouponToCart,
    removeCouponFromCart,
    mergeCarts,
    setGuestEmailOnCart,
    setShippingAddressesOnCart,
    setBillingAddressOnCart,
    setShippingMethodsOnCart,
    setPaymentMethodOnCart,
    placeOrder,
    completeStripePayment,
    getCardnetPaymentStatus,
    processCardnetPaymentSecureChallenge,
    restoreQuote,
    createPaymentOrder,
    amazonPayConfig,
    amazonExpressConfig,
    amazonExpressPay,
    updateRewardPoints,
    getStripeRequiresAction,
    generateExtendedHash,
}
